import { Content, Footer } from "antd/lib/layout/layout";
import { Col, Row, Typography } from "antd";
import { Insta, MainLogo, Twitter, Wifi, Youtube, Facebook } from "../../assets/images";
import { Link } from "react-router-dom";
import Localize, { isCart } from "../../utils/string";
import { useEffect, useState } from "react";
import { CartDetailShow } from "../../store/products/productsAsyncActions";
import { useDispatch, useSelector } from "react-redux";
interface Props {
  pathName: string;
}

const pathArray = ['releases', 'products', 'search', 'labels', 'login','profile','terms','policy','forgotPassword','cart'];

const FooterLayout = ({ pathName }: Props) => {
  const date = new Date();
  const [isCheckPathName, setIsCheckPathName] = useState<boolean>(false);
  const loginResp = useSelector((state: any) => state.user.userSession);
  const dispatch = useDispatch();
  const cartHandler = async () => {
    const Qparams: any = `?customerId=${loginResp?.userId}`;
    const response1: any = await dispatch(CartDetailShow(Qparams));
  }
  useEffect(() => {
    const pathParts = pathName.split("/");
    const isMatch = pathArray.some(part => pathParts.includes(part));
    setIsCheckPathName(isMatch);
    if(isCart) cartHandler();
  }, [pathName]);

  const footerContent = `©${date.getFullYear()} Prime Direct Distribution Ltd.`;
  const footerContent2 = `Website By`;
  return (
    <Footer className={`${!isCheckPathName ? 'footer-white' : ''}`}>
      <Content className="container">
        <Row>
          <Col className="left-footer" sm={24} xl={24}>
            <MainLogo />
          </Col>
          <Col className="center-footer" sm={24} xl={24}>
            {/* <div className="center-inner">
              <Link
                className={`${pathName === "/releases" && " active"}`}
                to="/releases"
              >
                {Localize.ReleaseLinkText}
              </Link>
              <Link
                className={`${pathName === "/labels" && " active"}`}
                to="/labels"
              >
                {Localize.LabelLinkText}
              </Link>
              <Link
                className={`${pathName === "/services" && " active"}`}
                to="/services"
              >
                {Localize.ServiceLinkText}
              </Link>
              <Link
                className={`${pathName === "/contact" && " active"}`}
                to="/contact"
              >
                {Localize.TeamLinkText}
              </Link>
            </div> */}
            <h1 className="ant-typography">Worldwide physical and digital distribution.
              From music lovers, to music lovers.</h1>
          </Col>
          <Col className="right-footer" sm={24} xl={24}>
            <div className="right-inner">
              <div className="right-inner-icons">
                <a href="https://www.instagram.com/primedirectdistribution" rel="noreferrer" target="_blank">
                  <Insta />
                </a>
                <a className="twitterIcon" href="https://twitter.com/primedirectdist" rel="noreferrer" target="_blank">
                  <Twitter />
                </a>
                <a href="https://www.facebook.com/PrimeDirectDistribution" rel="noreferrer" target="_blank">
                  <Facebook />
                </a>
                <a href=" https://open.spotify.com/user/primedirectdist?si=f127181e48bc48a9" rel="noreferrer" target="_blank">
                  <Wifi />
                </a>
              </div>
              <div className="footer-right-desc-text-spans">
                <Typography.Text className="">{Localize.FooterRightDesc}</Typography.Text>
                <Typography.Text className="">{Localize.FooterRightDesc65}</Typography.Text>
                <Typography.Text className="">{Localize.FooterRightDescLondon}</Typography.Text>
                <Typography.Text className="number">{Localize.FooterRightDescNumber}</Typography.Text>
                <Typography.Text className="mail">{Localize.FooterRightDescMail}</Typography.Text>
              </div>
            </div>
          </Col>
        </Row>
        <Typography.Text className="bottom-text">
          <Link to="/terms">{Localize.TermsConditionsText}</Link>
          <Link to="/policy">{Localize.PrivacyPolicy}</Link>
          {footerContent}
          <div>
            <span className="bottom-text" style={{ marginTop: "0", gap: '8px' }}>{footerContent2 + " "}<a href="https://anotherkind.co.uk/" target="_blank"> Another Kind</a></span>

          </div>
        </Typography.Text>
      </Content>
    </Footer>
  );
};

export default FooterLayout;
